import {Stack, Typography} from '@mui/material'
import AmountDisplay from "@/components/AmountDisplay";
import {useEffect} from "react";
interface Props {
  list: any[],
  amountVisible: boolean
}
const UserAssets = (props) => {
  const { list, amountVisible } = props
  useEffect(() => {

    if (list) {

    }
  }, [list]);

  return (<>
    <Stack>
      <Stack>
        {
          list?.map((item, index) => (<Stack
            key={item.varietyCode + index}
            sx={{height: '61px'}}
            direction="row" justifyContent="space-between" alignItems="center">
            <Stack direction="row" alignItems="center"
                   sx={{
                     gap: '10px',
                     '& > img': {
                       width: '28px',
                       height: '28px',
                     }
                   }}
            >
              <img src={`/images/coin/${item.varietyCode.toLowerCase()}.svg`}
                   alt={`${item.shortName}.png`}/>
              <Stack>
                <Typography fontSize='14px' fontWeight={'500'}>{item.shortName}</Typography>
                <Typography color="textTertiary" fontSize='11px' fontWeight={'400'}>{item.displayName}</Typography>
              </Stack>
            </Stack>
            <Stack direction="column" alignItems="flex-end">
              {/*<Typography>{item.available}</Typography>*/}
              <AmountDisplay fontSize='14px' fontWeight={'500'} amount={item.available} visible={amountVisible as Boolean} />
              <Stack direction="row" gap="4px">
                <Typography color="textTertiary" fontSize='11px'>≈</Typography>
                <AmountDisplay color="textTertiary" fontSize='11px' amount={item.currencyBalance} visible={amountVisible as Boolean} />
                <Typography color="textTertiary" fontSize='11px'>{item.currencyCode}</Typography>
              </Stack>

            </Stack>

          </Stack>))
        }
      </Stack>
    </Stack>
  </>)
}

export default UserAssets;